import { http } from '@/utils/http';
import qs from 'qs';

const baseUrl = 'vote/2020project/2020writing/controller.php?enews=';
// 名师列表
interface IVoteListOption {
  page?: number;
  search?: string | number;
}
export const voteListTeacher = ({ page, search }: IVoteListOption) => {
  return http.get(`${baseUrl}vote-list-teacher`, {
    params: { page, search },
  });
};

// 名著列表
export const voteListBook = ({ page, search }: IVoteListOption) => {
  return http.get(`${baseUrl}vote-list-book`, {
    params: { page, search },
  });
};

// 作文列表
export const voteList = ({ page, search }: IVoteListOption) => {
  return http.get(`${baseUrl}vote-list`, {
    params: { page, search },
  });
};

// 书籍下拉菜单
export const bookNameList = () => {
  return http.get(`${baseUrl}bookName_list`);
};

// 获取名师详情页面
export const detailTeacher = (id: any) => {
  return http.get(`${baseUrl}detail-teacher&id=` + id);
};

// 获取名师详情页面
export const detailBook = (id: any) => {
  return http.get(`${baseUrl}detail-book&id=` + id);
};

// 获取作文详情页面
export const detail = (id: any) => {
  return http.get(`${baseUrl}detail&id=` + id);
};

// 总助力
export const allNum = () => {
  return http.get(`${baseUrl}all-num`);
};

// 获取学校列表
export const getSchools = (search: any) => {
  return http.get(`${baseUrl}getSchools&search=` + search);
};
